/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} BenefitsInputs */

const en_benefits = /** @type {(inputs: BenefitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benefits`)
};

const de_benefits = /** @type {(inputs: BenefitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benefits`)
};

/**
* | output |
* | --- |
* | "Benefits" |
*
* @param {BenefitsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const benefits = /** @type {((inputs?: BenefitsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<BenefitsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_benefits(inputs)
	return en_benefits(inputs)
});